import React from 'react';
export function FolderAddIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6a1 1 0 011-1h4.558a1 1 0 01.95.684l.543 1.632A1 1 0 0012 8h7a1 1 0 011 1v3a1 1 0 102 0V9a3 3 0 00-3-3h-6.28l-.316-.949A3 3 0 009.559 3H5a3 3 0 00-3 3v12a3 3 0 003 3h8a1 1 0 100-2H5a1 1 0 01-1-1V6zm14 15a1 1 0 01-1-1v-2h-2a1 1 0 110-2h2v-2a1 1 0 112 0v2h2a1 1 0 110 2h-2v2a1 1 0 01-1 1z"
  }));
}